import { IS_LOADING, SET_DATA, SET_ERROR, SET_SUCCESS } from "./types";
import axios from "@/utils/axios";
import MessageDispatcher from "@/store/Crud/classes/MessageDispatcher";
import i18n from "@/i18n";
const messageDispatcher = new MessageDispatcher();
const upload = async (store, options) => {
    store.commit(IS_LOADING, true);
    store.commit(SET_SUCCESS, false);
    store.commit(SET_ERROR, null);
    return await axios
        .post(options.resource, options.data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
        .then((response) => {
        store.commit(SET_DATA, response.data);
        store.commit(SET_SUCCESS, true);
        if (!options.hideSuccessMessage) {
            //@ts-ignore
            messageDispatcher.dispatchSuccessMessage(store, i18n.global.t("messages.upload_success", "").toString());
        }
    })
        .catch((error) => {
        store.commit(SET_ERROR, error.response?.data);
    })
        .finally(() => {
        store.commit(IS_LOADING, false);
    });
};
export default {
    upload,
};
